import "core-js/modules/es.string.link.js";
export var paginationPortalTokens = {
  itemPaddingX: "12px",
  itemPaddingY: "6px",
  itemBorderRadius: "30px",
  itemFontColor: function itemFontColor(_ref) {
    var color = _ref.color;
    return color.text.black.base;
  },
  itemFontSizeName: "l",
  itemActiveBackgroundColor: function itemActiveBackgroundColor(_ref2) {
    var palette = _ref2.palette;
    return palette.neutralsBlack.hex10;
  },
  itemActiveFontColor: function itemActiveFontColor(_ref3) {
    var color = _ref3.color;
    return color.text.black.base;
  },
  itemHoverBackgroundColor: function itemHoverBackgroundColor(_ref4) {
    var palette = _ref4.palette;
    return palette.neutralsBlack.hex5;
  },
  itemHoverFontColor: function itemHoverFontColor(_ref5) {
    var color = _ref5.color;
    return color.text.link.hover;
  },
  navigationItemPaddingX: "7px",
  navigationItemPaddingY: "5px",
  navigationItemBorderRadius: "50px",
  spacingBetweenItems: "12px",
  iconStyle: "chevron"
};